<template>
  <v-card
    @click="navigateToProductPage"
    class="favourite mx-auto d-flex d-md-block"
    max-width="400"
    flat
  >
    <!-- <v-icon color="appRed" class="heart-icon">
      mdi-heart
    </v-icon> -->
    <div v-if="product.images" class="product-image-container">
      <img
        class="product-image"
        v-if="product.images.length > 0"
        :src="product.images[0].imageUrl"
        alt=""
      />
      <im
        class="product-image"
        v-else1
        src="https://i.stack.imgur.com/y9DpT.jpg"
        width="100%"
        alt=""
        srcset=""
      />
    </div>
    <v-card-text class="text--primary px-5">
      <!-- <discount-label
        count="10"
        class="mb-2"
        v-if="discount && !$vuetify.breakpoint.mobile"
      >
      </discount-label> -->

      <div class="d-flex justify-space-between pr-3">
        <div class="gotham-medium font-16 product-title">{{ product.name }}</div>
      </div>
      <div class="d-flex justify-space-between mb-3">
         <div>
          <div class="d-flex">
            <div class="d-flex">
              <i
                v-for="index in 5"
                :key="index"
                :class="{
                  'appOrange--text': index < product.reviewRating.average,
                  'appLightGrey100--text': index >= product.reviewRating.average,
                  'appLightGrey100--text': product.reviewRating.average== undefined
                  
                }"
                aria-hidden="true"
                class="v-icon notranslate mdi mdi-star theme--light v-rating"
              ></i>
            </div>
            <span class="ml-1 gotham-book font-14 text--lighten-1"
              >({{ product.reviewRating.outOf ? product.reviewRating.outOf : 0 }})</span
            >
          </div>
          <!-- <div class="gotham-book product-sales">301 Sales</div> -->
        </div>
      </div>
      <span class="price">
        £27
      </span>
      <!-- <div class="d-flex justify-space-between mb-3">
        <v-btn
          small
          elevation="0"
          color="appGreen"
          class="gotham-medium white--text text-none view-product w-100 pa-2"
        >
          View product
          <v-icon>
            mdi-arrow-right
          </v-icon>
        </v-btn>
      </div> -->
    </v-card-text>
  </v-card>
</template>

<script>
// import DiscountLabel from "@/components/Shared/DiscountLabel/DiscountLabel.vue";
export default {
  name: "ProductCard",
  components: {
  //  DiscountLabel
  },
  props: {
    product: Object,
    discount: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    rating: 5
  }),
  methods: {
    navigateToProductPage() {
      this.evtProductClicked(this.product);
      this.$router.push({
        name: "Product",
        params: {
          id: this.convertToSlug(this.product.name) + "-" + this.product.id
        }
      });
    },
    convertToSlug(Text) {
      return Text.toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");
    }
  }
};
</script>

<style scoped lang="scss" src="./ProductCard.scss"></style>

<style lang="scss">
.favourite {
  position: relative;
  .discount .discount-count {
    position: initial;
  }
  .price {
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 20px;
    font-family: Gotham-Medium;
  }
  .view-product {
    font-family: Gotham-Medium;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 30px;
    height: initial;
  }
  .brand {
    width: 30px;
    position: absolute;
    left: 10px;
    top: 5px;
    z-index: 1000;
  }
  .heart-icon {
    width: 24px;
    position: absolute;
    right: 10px;
    top: 5px;
    z-index: 1000;
  }
  .product-title {
    --max-lines: 2;
		position: relative;
		max-height: calc(1.4em * var(--max-lines));
		overflow: hidden;
		padding-right: 1rem; /* space for ellipsis */
		min-height: 44px;
  }
}
</style>
